import styled from 'styled-components';
import { theme } from 'styled-tools';
import Cta from './Cta';

const InvertedCta = styled(Cta)`
  color: ${theme('colors.orange')};
  background-color: ${theme('colors.white')};
  :hover {
    color: ${theme('colors.orange')};
  }
`;

export default InvertedCta;
